import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { useHistory, useParams } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { fuctions as utilFunctions } from './utils/functions';
import Loader from 'react-loader-spinner';
import ProtocolService from '../service';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ModalStatus from './components/ModalStatus';
import ModalUser from './components/ModalUser';
import ModalReason from './components/ModalReason';
import ModalSubReason from './components/ModalSubReason';
import ModalClient from './components/ModalClient';
import ModalRelations from './components/Relations';
import CommentsForm from './components/Comments/CommentsForm';
import { useReactToPrint } from 'react-to-print';
import IconG4 from 'assets/img/theme/iconG4.png';
import Select from 'react-select/async';
import { FlexController } from 'components/FlexControllerInput';
import { getDefaultCountry } from 'services/ServiceCOUNTRYS';
import {
  Container,
  Button,
  Row,
  Card,
  Form,
  Col,
  Input,
  CardHeader,
  CardBody
} from 'reactstrap';
import { validateFields, definedShowName } from '../form/assets/functions';
import { useProtocolDefaultFieldsSettings } from '../../fieldConfigs/hooks/useProtocolDefaultFieldsSettings';
import { PageToPrint } from './components/PageToPrint';
import { Print } from './components/PageToPrint/styles';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import CustomFieldsInputsForm from 'views/CRM/shared/components/CustomFieldsInputsForm';
import {
  formatCustomFieldsToDisplay,
  formatCustomFieldsToSubmit,
  removeTelephoneAuxiliaryFields
} from 'views/CRM/shared/helpers/customFieldsHelpers';
import { useClickToCallOnPhoneField } from 'views/CRM/shared/hooks/useClickToCallOnPhoneField';
import { ProtocolAttachments } from './components/Attachments';
import { custom_select } from 'assets/styles/multiple_select';
import { useSearchAccounts } from 'views/CRM/Account/hooks/useSearchAccounts';
import ListSchedules from './components/Schedules/SchedulesList';
import ModalSchedulingProtocol from '../form/components/ModalSchedulingProtocol';
import CommentContainer from './components/Comments/CommentContainer';
import ProtocolSchedulingService from '../service/ProtocolSchedulingService';
import { removeMaskSpecialCharacters } from 'views/CRM/shared/utils/phoneNumberHelpers';
import TemplatesModal from 'views/ServicePanel/components/QueueContent/components/Contact/TemplatesModal';
import { useCustomFields } from '../form/context/CustomFieldsContext';
import ProtocolModal from 'components/Navbars/ServicePanel/ProtocolModal';
import { SubProtocolList } from './components/SubProtocolList';
import SlaActivityHistory from './components/Comments/SlaActivityHistory';
import ShowMoreButton from './components/Comments/SlaActivityHistory/components/ShowMoreButton';
import ModalSLAInfo from './components/ModalSLAInfo';
import ProtocolSLAInfoService from '../../SLA/ProtocolSLAInfo/service';
import RecordTypeService from '../../RecordType/service';
import 'react-quill/dist/quill.snow.css';
import { DescriptionContainer } from './components/Description';
import { useImageUrl } from 'hooks/useImageSrc';
import { RepliedCommentContainer } from './components/Comments/RepliedCommentContainer';
import { ForwardedCommentContainer } from './components/Comments/ForwardedCommentContainer';
import DOMPurify from 'dompurify';
import ModalRecordType from './components/ModalRecordType';
import AddAccountModal from '../../CRM/Contact/form/AddAccountModal';
import EditAccountModal from '../../CRM/Contact/form/EditAccountModal/EditAccountModal';
import ModalFilterClients from 'views/Clients/components/ModalFilterClients';
import { SearchContactButton } from '../../../components/Buttons/SearchContactButton';
import { AddNewContactButton } from '../../../components/Buttons/AddNewContactButton';
import AccountService from '../../CRM/Account/services/accountService';
import ProtocolConfigService from '../../ProtocolConfiguration/service/index';
import StatusService from '../../status/service';
import { DescriptionUpdateProtocolQuillContainer } from '../form/components/ProtocolForm/styles';
import { ClientProtocol } from 'views/Clients/list/components/ClientProtocol';
import { useRecordTypesByUser } from 'views/RecordType/hooks/useRecordTypesByUser';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { AccountProtocol } from 'views/CRM/Account/list/components/AccountProtocol';
import { PrintFieldsSelectionModal } from './components/PrintFieldsSelectionModal';
import { ModalNotificationAgent } from './components/ModalNotificationAgent';

export const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    [{ font: [] }],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' }
    ],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    ['link', 'image', 'code-block'],
    ['clean']
  ]
};

const { formatDataUpdateProtocol, omitFields, initializeFromLocalStorage } =
  utilFunctions();

const ProtocolFormUpdate = () => {
  const { id } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [protocol, setProtocol] = useState();
  const parentProtocol = protocol?.parent;
  const subProtocols = protocol?.subProtocols || [];
  const [openModalStatus, setOpenModalStatus] = useState(false);
  const [openModalUser, setOpenModalUser] = useState(false);
  const [openModalNotificationAgent, setOpenModalNotificationAgent] =
    useState(false);
  const [openModalReason, setOpenModalReason] = useState(false);
  const [openModalSubReason, setOpenModalSubReason] = useState(false);
  const [openModalUpdateClient, setOpenModalUpdateClient] = useState(false);
  const [openModalRelations, setOpenModalRelations] = useState(false);
  const [returnPath, setReturnPath] = useState(
    initializeFromLocalStorage().returnPath
  );
  const [recordTypeId, setRecordTypeId] = useState(
    history.location.state?.recordTypeId ||
      initializeFromLocalStorage().recordTypeId
  );
  const [valueDescription, setValueDescription] = useState('');
  const [account, setAccount] = useState();
  const [, setHasAccountError] = useState(false);
  const [valueFieldsReferenceLoading, setValueFieldsReferenceLoading] =
    useState(true);
  const [listComments, setListComments] = useState([]);
  const [listSchedules, setListSchedules] = useState([]);
  const [isSchedulingModalOpen, setIsSchedulingModalOpen] = useState(false);
  const [isToUpdateScheduling, setIsToUpdateScheduling] = useState(false);
  const [isToCreateScheduling, setIsToCreateScheduling] = useState(false);
  const [schedulingId, setschedulingId] = useState();
  const [isCurrentResponsible, setIsCurrentResponsible] = useState('');
  const [
    isModalTemplateMessageProtocolOpen,
    setIsisModalTemplateMessageProtocolOpen
  ] = useState(false);
  const [
    whatsAppMessageContactInfoProtocol,
    setWhatsAppMessageContactInfoProtocol
  ] = useState({});
  const { control, errors, handleSubmit, setValue, reset, watch } = useForm();
  const [isEditing, setIsEditing] = useState(false);
  const { canMakeCall, canSendMessage } = useClickToCallOnPhoneField();
  const { isSearching, filterAccounts } = useSearchAccounts();
  const { changeFieldsReference, getValueFieldsReference } = useCustomFields();
  const [isProtocolModalOpen, setIsProtocolModalOpen] = useState(false);
  const [userLogin, setUserLogin] = useState(null);
  const [isProtocolSLAModalOpen, setIsProtocolSLAModalOpen] = useState(false);
  const [visibleGroups, setVisibleGroups] = useState({});
  const [isUserAbleToEditSlaInfo, setIsUserAbleToEditSlaInfo] = useState(true);
  const [isLoadingSLAInfo, setIsLoadingSLAInfo] = useState(false);
  const [protocolSLAInfoTime, setProtocolSLAInfoTime] = useState(null);
  const [isUsingSLA, setIsUsingSLA] = useState(false);
  const storedValueRoute = localStorage.getItem('valueRoute');
  const { buildImageUrl } = useImageUrl();
  const [replyComment, setReplyComment] = useState(null);
  const [isForwardingComment, setIsForwardingComment] = useState(false);
  const [selectedComments, setSelectedComments] = useState([]);
  const [isModalRecordTypeOpen, setIsModalRecordTypeOpen] = useState(false);
  const [isAutoMappingModalOpen, setIsAutoMappingModalOpen] = useState(false);
  const [isPrintFieldsModalOpen, setIsPrintFieldsModalOpen] = useState(false);
  const [selectedPrintFields, setSelectedPrintFields] = useState({});
  const [fieldLayouts, setFieldLayouts] = useState([]);
  const [currentStatusDisplay, setCurrentStatusDisplay] = useState({
    id: '',
    name: ''
  });

  const { recordTypes, getRecordTypesByUser } = useRecordTypesByUser(
    entitiesName.PROTOCOL
  );

  useEffect(() => {
    getRecordTypesByUser();
  }, [getRecordTypesByUser]);
  const [isClientSearchModalOpen, setIsClientSearchModalOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    async function fetchPositions() {
      if (!recordTypeId || !ProtocolConfigService?.getProtocolPosition) return;
      try {
        const res = await ProtocolConfigService.getProtocolPosition(
          recordTypeId,
          'PROTOCOL'
        );
        const positions = res?.data?.positions || [];
        if (mounted) setFieldLayouts(Array.isArray(positions) ? positions : []);
      } catch (err) {
        console.log(err);
        setFieldLayouts([]);
      }
    }
    fetchPositions();
    return () => {
      mounted = false;
    };
  }, [recordTypeId]);

  useEffect(() => {
    const objetoString = localStorage.getItem('valueRoute');
    if (objetoString) {
      const objectFromLocal = JSON.parse(objetoString);
      const { recordTypeId: localRecordTypeId, returnPath } = objectFromLocal;

      const newRecordTypeId =
        history.location.state?.recordTypeId || localRecordTypeId;

      if (newRecordTypeId && newRecordTypeId !== recordTypeId) {
        setRecordTypeId(newRecordTypeId);
      }

      setReturnPath(returnPath);
    }
  }, [id, history.location.state]);

  const { protocolDefaultFieldsDisplaySettings } =
    useProtocolDefaultFieldsSettings(recordTypeId);
  const { customFields, getCustomFields } = useEntityCustomFieldsByRecordType(
    'PROTOCOL',
    recordTypeId
  );

  const byYX = (a, b) => a.y - b.y || a.x - b.x;

  const getFallbackStatusName = useCallback((protocolData) => {
    if (!protocolData) return '';
    return (
      protocolData?.protocol_statuses?.[0]?.status?.name ||
      protocolData?.protocol_statuses?.[0]?.name ||
      ''
    );
  }, []);

  const getCurrentStatusId = useCallback((protocolData) => {
    if (!protocolData) return '';
    return (
      protocolData?.current_status?.id ||
      protocolData?.current_status ||
      protocolData?.protocol_statuses?.[0]?.status?.id ||
      protocolData?.protocol_statuses?.[0]?.id ||
      ''
    );
  }, []);
  const layoutIndex = React.useMemo(() => {
    return new Map(
      (fieldLayouts || [])
        .filter((l) => l && l.i != null)
        .map((l) => [String(l.i).trim(), l])
    );
  }, [fieldLayouts]);

  const sortedCustomFields = React.useMemo(() => {
    if (!Array.isArray(customFields) || customFields.length === 0) return [];
    const withPos = [];
    const withoutPos = [];
    customFields.forEach((f, idx) => {
      const key = String(f.id).trim();
      const lay = layoutIndex.get(key);
      if (lay && Number.isFinite(lay.y) && Number.isFinite(lay.x)) {
        withPos.push({ f, x: lay.x, y: lay.y });
      } else {
        withoutPos.push({ f, idx });
      }
    });
    withPos.sort(byYX);
    withoutPos.sort((a, b) => a.idx - b.idx);
    return [...withPos.map((o) => o.f), ...withoutPos.map((o) => o.f)];
  }, [customFields, layoutIndex]);

  /**
   * Converte o telefone do protocolo para o formato do FlexController
   * @param {string} telephone - Telefone no formato string
   * @param {string} ddi - DDI separado se disponível
   * @returns {object} - Objeto com ddi e number
   */
  const convertTelephoneToFlexFormat = (telephone, ddi) => {
    if (!telephone)
      return {
        ddi: ddi || getDefaultCountry()?.dialCode || '',
        number: ''
      };
    if (typeof telephone === 'object' && telephone.ddi && telephone.number) {
      return telephone;
    }
    return {
      ddi: ddi || getDefaultCountry()?.dialCode,
      number: telephone
    };
  };

  const handleRedirect = useCallback(
    (id, recordTypeId) => {
      history.push(`/admin/protocol/${id}/update`, {
        recordTypeId: recordTypeId,
        returnPath: '/admin/protocol'
      });
    },
    [history]
  );

  const [isAccountSearchModalOpen, setIsAccountSearchModalOpen] =
    useState(false);
  const [isEditAccountModalOpen, setIsEditAccountModalOpen] = useState(false);
  const [accountResponse, setAccountResponse] = useState({});

  const getAccount = async (recordTypeId, id) => {
    await AccountService.getById(recordTypeId, id)
      .then((response) => {
        setAccountResponse(response?.data?.data);
      })
      .catch(() => {
        toast.error('Ocorreu um erro ao buscar informações da conta');
      });
  };

  const handleEditAccount = async () => {
    if (account && account.value) {
      try {
        await getAccount(account?.recordTypeId, account?.value);
        setIsEditAccountModalOpen(true);
      } catch (error) {
        console.log(error);
        toast.error('Ocorreu um erro ao buscar informações da conta');
      }
    } else {
      toast.error('Nenhuma conta selecionada ou recordTypeId inválido');
    }
  };

  useEffect(() => {
    const userLogin = localStorage.getItem('login');
    if (!userLogin) {
      return null;
    }
    setUserLogin(userLogin);
  });

  useEffect(() => {
    const valueRoute = JSON.parse(storedValueRoute);
    const returnPath = valueRoute?.returnPath;
    const handlePopState = () => {
      window.location.href = returnPath || '/admin/protocol';
    };
    window.addEventListener('popstate', handlePopState);
    window.history.pushState(null, '', window.location.href);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    if (listComments.length !== 0) {
      const baseURL = buildImageUrl('');
      listComments.forEach((comment) => {
        if (!comment.description.includes(baseURL)) {
          comment.description = comment.description.replace(
            /protocol-attachments/g,
            `${baseURL}/protocol-attachments`
          );
        }
      });
    }
  }, [listComments]);

  const getProtocolById = useCallback(() => {
    if (id) {
      setLoading(true);
      if (recordTypeId) {
        ProtocolService.getByIdAndRecordType(id, recordTypeId)
          .then((res) => {
            const protocolData = res.data.content;
            const protocolScheduleData = res.data.content.schedules;
            const protocolScheduleDataResponsible = userLogin;
            const protocolDTO = formatCustomFieldsToDisplay(
              protocolData,
              customFields
            );
            setProtocol(protocolDTO);
            setIsCurrentResponsible(protocolScheduleDataResponsible);
            setListSchedules(protocolScheduleData);
            if (protocolData.account) {
              setAccount({
                label: protocolData?.account?.name,
                value: protocolData?.account?.id,
                recordTypeId: protocolData.account?.record_type_id
              });
            }
            reset({
              ...protocolDTO,
              phone: {
                ddi: protocolDTO.client?.ddi || '',
                number: protocolDTO.client?.telefone || ''
              }
            });
            setValueDescription(protocolDTO?.description || '');
            setLoading(false);
          })
          .catch((erro) => {
            console.log('erro: ', erro);
            toast.error('Erro ao carregar o protocolo', {
              autoClose: 3000,
              closeOnClick: true
            });
          });
      }
    }
  }, [id, recordTypeId, customFields, reset, valueFieldsReferenceLoading]);

  const getCommnents = useCallback(() => {
    if (id) {
      ProtocolService.getAllComments(id)
        .then((res) => {
          setListComments(res.data.content);
          setLoading(false);
        })
        .catch((err) => {
          console.log('err', err);
        });
    }
  }, [id]);

  useEffect(() => {
    setLoading(true);
    if (!recordTypeId) return;
    RecordTypeService.getById(recordTypeId)
      .then((response) => {
        const recordType = response.data.content;
        if (recordType) {
          setIsUsingSLA(recordType.is_sla_active);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [recordTypeId]);

  useEffect(() => {
    const login = localStorage.getItem('login');
    if (!login) return;
    if (!isUsingSLA) return;
    if (login) {
      setLoading(true);
      ProtocolSLAInfoService.canUserEditSLA(id, login)
        .then((response) => {
          const canUserEdit = response.data.content;
          setIsUserAbleToEditSlaInfo(canUserEdit);
          setIsLoadingSLAInfo(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoadingSLAInfo(false);
        });
    }
  }, [id, isUsingSLA]);

  useEffect(() => {
    setIsLoadingSLAInfo(true);
    if (!isUsingSLA) return;
    ProtocolSLAInfoService.reCalculateSLATime(id)
      .then((response) => {
        setProtocolSLAInfoTime(response.data.content);
        setIsLoadingSLAInfo(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoadingSLAInfo(false);
      });
  }, [id, isUsingSLA, isProtocolSLAModalOpen]);

  useEffect(getProtocolById, [getProtocolById]);
  useEffect(getCommnents, [getCommnents]);
  useEffect(() => {
    getCustomFields();
  }, [getCustomFields]);

  useEffect(() => {
    Object.keys(protocol || []).forEach((key) => {
      if (protocol[key] && key === 'current_status') {
        setValue(
          key,
          currentStatusDisplay.name || getFallbackStatusName(protocol) || ''
        );
      } else if (protocol[key] && key === 'client_id') {
        setValue(key, protocol?.client?.nome || '');
      } else if (protocol[key] && key === 'reason_id') {
        setValue(key, protocol?.reason?.name || '');
      } else if (protocol[key] && key === 'subreason_id') {
        setValue(key, protocol?.subreason?.name || '');
      } else if (key === 'telephone') {
        setValue(
          'phone',
          convertTelephoneToFlexFormat(protocol?.telephone, protocol?.ddi)
        );
      } else {
        setValue(key, protocol[key] || '');
      }
    });
  }, [
    protocol,
    customFields,
    setValue,
    reset,
    currentStatusDisplay.name,
    getFallbackStatusName
  ]);

  useEffect(() => {
    const currentStatusId = getCurrentStatusId(protocol);
    if (!currentStatusId) {
      setCurrentStatusDisplay({
        id: '',
        name: getFallbackStatusName(protocol)
      });
      return;
    }

    StatusService.get(currentStatusId)
      .then((response) => {
        setCurrentStatusDisplay({
          id: currentStatusId,
          name:
            response?.data?.content?.name ||
            getFallbackStatusName(protocol) ||
            ''
        });
      })
      .catch(() => {
        setCurrentStatusDisplay({
          id: currentStatusId,
          name: getFallbackStatusName(protocol) || ''
        });
      });
  }, [protocol, getCurrentStatusId, getFallbackStatusName]);

  useEffect(() => {
    if (customFields.length === 0) setValueFieldsReferenceLoading(false);
    setValueFieldsReferenceLoading(true);
    let valueFieldsReferenceCopy = { ...getValueFieldsReference() };
    if (protocol) {
      customFields.length > 0 &&
        customFields.map((field) => {
          if (Object.keys(field).length && !field?.isReference && field?.name) {
            valueFieldsReferenceCopy[field.parentName] =
              field.options
                .filter((opt) => opt.value === protocol[field.name])[0]
                ?.parentsValue?.map((item) => ({ label: item, value: item })) ||
              [];
          }
        });
      changeFieldsReference(valueFieldsReferenceCopy);
      setValueFieldsReferenceLoading(false);
    }
  }, [customFields, protocol]);

  const selectNameToActiveContactMessage = () => {
    if (!protocol) return;
    return protocol?.client?.nome
      ? protocol?.client?.nome
      : protocol?.account?.name || '';
  };

  const handleSendDescription = (value) => {
    setValueDescription(value);
  };

  function handleWhatsAppMessage(phone) {
    let ddi = '';
    let number = '';
    if (typeof phone === 'object' && phone !== null) {
      ddi = phone.ddi || '';
      number = phone.number || '';
    } else if (typeof phone === 'string') {
      number = phone;
    }
    const phoneNumberWithoutMask = removeMaskSpecialCharacters(number);
    let data = {
      nome: selectNameToActiveContactMessage(),
      telefone: phoneNumberWithoutMask !== '' ? phoneNumberWithoutMask : '',
      ddi: ddi
    };
    setWhatsAppMessageContactInfoProtocol(data);
    setIsisModalTemplateMessageProtocolOpen(
      !isModalTemplateMessageProtocolOpen
    );
    return whatsAppMessageContactInfoProtocol;
  }

  const cancelAction = () => {
    const path = returnPath;
    history.push(path, { recordTypeId } || null);
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const handleUpdateComment = (commentId) => {
    return async (data) => {
      try {
        await ProtocolService.updateComment(id, commentId, data);
        toast.success('Comentário atualizado com sucesso', {
          autoClose: 3000,
          closeOnClick: true
        });
        getCommnents();
      } catch (error) {
        const msg = error?.response?.data?.message;
        toast.error(msg || 'Ocorreu um erro ao atualizar comentário');
      }
    };
  };

  const handleDeleteComment = (commentId) => {
    return async () => {
      if (!window.confirm('Apagar comentário?')) return;
      try {
        await ProtocolService.deleteComment(id, commentId);
        toast.success('Comentário excluido com sucesso', {
          autoClose: 3000,
          closeOnClick: true
        });
        getCommnents();
      } catch (error) {
        const msg = error?.response?.data?.message;
        toast.error(msg || 'Ocorreu um erro ao deletar comentário');
      }
    };
  };

  const handleSubmitComment = async (formData) => {
    try {
      await ProtocolService.createCommentProtocol(id, formData);
      toast.success('Comentário adicionado com sucesso', {
        autoClose: 3000,
        closeOnClick: true
      });
      getCommnents();
      setReplyComment(null);
    } catch (error) {
      const msg = error?.response?.data?.message;
      toast.error(msg || 'Erro ao adicionar comentário');
    }
  };

  const handleSubmitForward = async (formData) => {
    try {
      if (selectedComments.length === 0) {
        toast.error('Selecione pelo menos um comentário para encaminhar');
        return;
      }
      if (!(formData instanceof FormData)) {
        console.error('Erro: formData não é uma instância de FormData');
        return;
      }
      await ProtocolService.forwardComments(id, selectedComments, formData);
      toast.success('Comentários encaminhados com sucesso');
      setSelectedComments([]);
      setIsForwardingComment(false);
      getCommnents();
    } catch (error) {
      console.error('Erro ao encaminhar:', error);
      const msg = error?.response?.data?.message;
      toast.error(msg || 'Erro ao encaminhar comentários');
    }
  };

  const updateProtocol = async (data) => {
    try {
      if (
        protocolDefaultFieldsDisplaySettings?.account_id?.isActive &&
        protocolDefaultFieldsDisplaySettings?.account_id?.isRequired &&
        !account
      ) {
        setHasAccountError(true);
        return;
      }
      data.description = valueDescription;
      if (
        protocolDefaultFieldsDisplaySettings?.description?.isActive &&
        protocolDefaultFieldsDisplaySettings?.description?.isRequired &&
        (!valueDescription ||
          valueDescription.trim() === '' ||
          valueDescription === '<p><br></p>')
      ) {
        toast.error('Descrição é obrigatória');
        return;
      }

      // OBS.: Esses dados foram removidos por recusa do backend em aceitar campos além dos necessários. O componente manda esses dados por questão de compatibilidade com outros formulários.
      const dataToSubmit = omitFields(formatDataUpdateProtocol(data), [
        'phone_ddi',
        'phone_number',
        'phone',
        'ddi',
        'new_agent_id'
      ]);

      let dataDTO = formatCustomFieldsToSubmit(
        removeTelephoneAuxiliaryFields(dataToSubmit, customFields),
        customFields
      );

      const dataSubmitWithoutNull = Object.fromEntries(
        Object.entries(dataDTO).filter(([, v]) => v != null)
      );
      if (account) {
        dataSubmitWithoutNull.account_id = account.value;
      }

      try {
        await ProtocolService.updateByRecordType(
          id,
          recordTypeId,
          dataSubmitWithoutNull
        );
        toast.success('Protocolo atualizado com sucesso!');
        getProtocolById();
      } catch (error) {
        toast.error('Falha ao atualizar o protocolo.');
      }
    } catch (error) {
      toast.error('Erro ao atualizar o protocolo');
    }
  };

  const cancelSchedule = (scheduleId) => {
    if (!window.confirm('Cancelar agendamento?')) {
      return;
    } else {
      ProtocolSchedulingService.cancelProtocolSchedule(scheduleId)
        .then(() => {
          toast.success('Agendamento cancelado com sucesso', {
            autoClose: 3000,
            closeOnClick: true
          });
          getProtocolById();
        })
        .catch((error) => {
          toast.error(
            error || 'Houve um erro ao tentar cancelar o agendamento.',
            {
              autoClose: 3000,
              closeOnClick: true
            }
          );
        });
    }
  };

  const handleUpdateSchedule = (dataSchedule) => {
    setIsSchedulingModalOpen(true);
    setIsToUpdateScheduling(true);
    setschedulingId(dataSchedule.id);
    setIsToCreateScheduling(false);
  };

  const componentRef = useRef(null);
  const executePrint = useReactToPrint({
    content: () => componentRef.current
  });

  const handlePrint = () => {
    setIsPrintFieldsModalOpen(true);
  };

  const handleConfirmPrintFields = (selectedFields) => {
    setSelectedPrintFields(selectedFields);
    setTimeout(() => {
      executePrint();
    }, 100);
  };

  const transformComments = (comments) => {
    const groupedComments = [];
    let tempGroup = [];
    comments.forEach((comment, index) => {
      if (comment.is_sla_info) {
        tempGroup.push(comment);
        if (
          !comments[index + 1]?.is_sla_info ||
          index === comments.length - 1
        ) {
          groupedComments.push({
            isGroup: true,
            comments: tempGroup,
            count: tempGroup.length
          });
          tempGroup = [];
        }
      } else {
        groupedComments.push(comment);
      }
    });
    return groupedComments;
  };

  const scrollQuillForm = useRef(null);
  const scrollToQuillCommentForm = () => {
    if (scrollQuillForm.current) {
      scrollQuillForm.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleReplyComment = (comment) => {
    setIsForwardingComment(false);
    setSelectedComments([]);
    setReplyComment(comment);
  };

  const handleForwardComment = (isChecked) => {
    if (isChecked) {
      setReplyComment(null);
    }
    scrollToQuillCommentForm();
  };

  const handleForwardAll = () => {
    setReplyComment(null);
    const allCommentIds = listComments
      .filter((c) => !c.is_sla_info)
      .map((c) => c.id);
    setSelectedComments(allCommentIds);
    setIsForwardingComment(true);
    scrollToQuillCommentForm();
  };

  const handleSelectComment = (comment) => {
    setReplyComment(null);
    setSelectedComments([comment.id]);
    setIsForwardingComment(true);
    scrollToQuillCommentForm();
  };

  const handleCloseReplyCommentBox = () => {
    setReplyComment(null);
  };

  const getParentComment = (commentId) =>
    commentId ? listComments.find((comment) => comment.id === commentId) : null;

  const getCommentsForwarded = (item) => {
    if (!item.forwards || item.forwards.length === 0) return [];
    if (item.forwards[0].include_full_history) return [];
    const commentIds = item.forwards[0].items.map((item) => item.comment_id);
    return listComments.filter((comment) => commentIds.includes(comment.id));
  };

  /**
   * Formats the recipients list for a comment based on its type (reply or forward)
   * @param {Object} replyComment - The comment object containing recipient information
   * @returns {string} - Comma-separated list of recipient emails/names
   */
  const formatCommentRecipients = (replyComment) => {
    if (!replyComment) return '';

    // Handle reply comments with "reply to all" enabled
    // Combines the original sender and all recipients into a single list
    if (replyComment?.reply_to_comment && replyComment.replyToAll) {
      return [replyComment?.from, ...(replyComment?.to ?? [])]
        .filter(Boolean)
        .join(', ');
    }

    // Handle forwarded comments with "reply to all" enabled
    // Creates a unique set of recipients combining the current user and forward recipients
    if (
      replyComment.forwards &&
      replyComment.forwards.length > 0 &&
      replyComment.replyToAll
    ) {
      const recipients = new Set(
        [
          replyComment?.user?.email || '',
          ...(replyComment?.forwards[0]?.recipients ?? [])
        ].filter(Boolean)
      );
      return Array.from(recipients).join(', ');
    }

    // Default case: return single recipient (either user email or from field)
    return replyComment?.user?.email || replyComment?.from || '';
  };

  const handleChangeRecordType = (newRecordType) => {
    // Se for objeto, pega o valor, senão usa direto
    const id =
      typeof newRecordType === 'object' && newRecordType !== null
        ? newRecordType.recordTypeId || newRecordType.value || newRecordType.id
        : newRecordType;
    setRecordTypeId(id);
    setIsModalRecordTypeOpen(false);
    toast.success('Tipo de registro alterado com sucesso!');
  };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath={returnPath || '/admin/protocol'}
        buttonTitle="Voltar para a pagina anterior"
        navigatorState={{ recordTypeId }}
      />
      <div style={{ display: 'none' }}>
        <Print ref={componentRef}>
          {protocol ? (
            <>
              <PageToPrint
                protocolNumber={protocol.number}
                comments={listComments}
                protocolData={protocol}
                defaultFields={protocolDefaultFieldsDisplaySettings}
                customFields={customFields}
                selectedFields={selectedPrintFields}
              />
              <img className="g4Img" src={IconG4} />
            </>
          ) : null}
        </Print>
      </div>
      <PrintFieldsSelectionModal
        isOpen={isPrintFieldsModalOpen}
        toggle={() => setIsPrintFieldsModalOpen(false)}
        onConfirm={handleConfirmPrintFields}
        defaultFields={protocolDefaultFieldsDisplaySettings}
        customFields={customFields}
      />
      <>
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <div className="card-wrapper">
                <Card>
                  <CardHeader
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    {protocol && (
                      <h3 className="mb-0">
                        Nº. do Protocolo {protocol.number}
                      </h3>
                    )}
                    <div>
                      <Button
                        style={{
                          alignSelf: 'flex-end',
                          marginLeft: 10,
                          backgroundColor: '#6c757d',
                          color: 'white'
                        }}
                        onClick={() => setIsModalRecordTypeOpen(true)}
                      >
                        Alterar tipo de registro
                      </Button>
                      <ModalRecordType
                        isModalOpen={isModalRecordTypeOpen}
                        onModalToggle={setIsModalRecordTypeOpen}
                        onSelected={handleChangeRecordType}
                        protocolId={protocol?.id}
                        prevRecordTypeId={protocol?.record_type_id}
                        prevCustomFields={customFields}
                        isAutoMappingModalOpen={isAutoMappingModalOpen}
                        onAutoMappingModalToggle={setIsAutoMappingModalOpen}
                      />
                      <Button
                        style={{
                          alignSelf: 'flex-end',
                          marginLeft: 10,
                          backgroundColor: `${isUsingSLA ? '#077A7C' : 'gray'}`,
                          color: 'white'
                        }}
                        onClick={() => setIsProtocolSLAModalOpen(true)}
                        disabled={!isUsingSLA}
                      >
                        SLA
                      </Button>
                      <ModalSLAInfo
                        isModalOpen={isProtocolSLAModalOpen}
                        onModalToggle={setIsProtocolSLAModalOpen}
                        protocolSLAInfoTime={protocolSLAInfoTime}
                        isLoadingSLAInfo={isLoadingSLAInfo}
                      />
                      <Button
                        style={{
                          alignSelf: 'flex-end',
                          marginLeft: 10,
                          backgroundColor: `#0000ff`,
                          color: 'white'
                        }}
                        onClick={() => {
                          localStorage.setItem('isFromUpdate', true);
                          setIsProtocolModalOpen(true);
                        }}
                      >
                        Sub Protocolo
                      </Button>
                      <ProtocolModal
                        isModalOpen={isProtocolModalOpen}
                        onModalToggle={setIsProtocolModalOpen}
                        unmountOnClose={true}
                        createdFrom={id}
                        fatherProtocol={{
                          protocol,
                          account,
                          contato: protocol?.client
                        }}
                        onProtocolUpdate={getProtocolById}
                      />
                      <Button
                        style={{
                          alignSelf: 'flex-end',
                          marginLeft: 10,
                          backgroundColor: `${
                            protocol?.cdr_report === null &&
                            protocol?.conversa === null
                              ? 'gray'
                              : '#5e72e4'
                          }`,
                          color: 'white',
                          cursor: `${
                            !protocol?.cdr_report && !protocol?.conversa
                              ? 'default'
                              : 'pointer'
                          }`
                        }}
                        disabled={!protocol?.cdr_report && !protocol?.conversa}
                        title={
                          protocol?.cdr_report === null &&
                          protocol?.conversa === null
                            ? 'Esse protocolo não possui conversas/chamadas relacionadas'
                            : 'Clique para visualizar as conversas/chamadas relacionadas a este protocolo'
                        }
                        onClick={() => setOpenModalRelations(true)}
                      >
                        Dados do Atendimento
                      </Button>
                      <ModalRelations
                        isModalOpen={openModalRelations}
                        onModalToggle={setOpenModalRelations}
                        protocolRelation={protocol ? protocol : []}
                        setLoading={setLoading}
                      />
                      <Button
                        color="danger"
                        style={{
                          alignSelf: 'flex-end'
                        }}
                        onClick={() => {
                          handlePrint();
                        }}
                      >
                        Imprimir
                      </Button>
                    </div>
                  </CardHeader>
                  <CardBody>
                    {loading ? (
                      <Row className="justify-content-md-center">
                        <Loader
                          type="TailSpin"
                          color="#35ac50"
                          height={100}
                          width={100}
                        />
                      </Row>
                    ) : (
                      protocol && (
                        <>
                          <Form
                            className="needs-validation"
                            onSubmit={handleSubmit(updateProtocol)}
                          >
                            {protocolDefaultFieldsDisplaySettings &&
                              !!Object.keys(
                                protocolDefaultFieldsDisplaySettings
                              ).length && (
                                <>
                                  <Card
                                    style={{
                                      marginLeft: '-24px',
                                      marginRight: '-24px',
                                      marginBottom: '10px',
                                      borderBottom: '1px solid #d3d3d3',
                                      marginTop: '-23px'
                                    }}
                                  >
                                    <CardBody>
                                      <Row className="mb-3">
                                        {protocolDefaultFieldsDisplaySettings
                                          .title?.isActive && (
                                          <Col
                                            md={
                                              protocolDefaultFieldsDisplaySettings
                                                .telephone.isActive
                                                ? { size: 6 }
                                                : { size: 12 }
                                            }
                                          >
                                            <label className="form-control-label">
                                              {definedShowName(
                                                'Titulo',
                                                protocolDefaultFieldsDisplaySettings
                                                  .title.isRequired
                                              )}
                                            </label>
                                            <Controller
                                              as={Input}
                                              control={control}
                                              name="title"
                                              defaultValue={protocol?.title}
                                              disabled={false}
                                              rules={
                                                protocolDefaultFieldsDisplaySettings
                                                  .title.isRequired
                                              }
                                            />
                                            <ErrorMessage
                                              errors={errors}
                                              name="title"
                                              render={({ message }) =>
                                                errorFormMessage(message)
                                              }
                                            />
                                          </Col>
                                        )}
                                        {protocolDefaultFieldsDisplaySettings
                                          .telephone.isActive && (
                                          <Col
                                            md={
                                              protocolDefaultFieldsDisplaySettings
                                                .title.isActive
                                                ? { size: 6 }
                                                : { size: 12 }
                                            }
                                          >
                                            <FlexController
                                              type="phone"
                                              label="Telefone"
                                              name="phone"
                                              disabled={true}
                                              showMessageButton={canSendMessage}
                                              showCallButton={canMakeCall}
                                              handleSendTemplate={
                                                handleWhatsAppMessage
                                              }
                                              watch={watch}
                                              canCleanData={false}
                                              value={watch('phone')}
                                              control={control}
                                              errors={errors}
                                              valueController={(
                                                fieldName,
                                                value
                                              ) => {
                                                setValue(fieldName, value);
                                              }}
                                            />
                                          </Col>
                                        )}
                                      </Row>
                                      <Row className="mb-3">
                                        {protocolDefaultFieldsDisplaySettings
                                          .description.isActive && (
                                          <Col md={{ size: 12 }}>
                                            <label className="form-control-label">
                                              {definedShowName(
                                                'Descrição',
                                                protocolDefaultFieldsDisplaySettings
                                                  .description.isRequired
                                              )}
                                            </label>
                                            {!isEditing ? (
                                              <DescriptionContainer
                                                className="protocol-description-editor"
                                                onClick={() =>
                                                  setIsEditing(true)
                                                }
                                                dangerouslySetInnerHTML={{
                                                  __html: DOMPurify.sanitize(
                                                    protocol?.description ?? ''
                                                  )
                                                }}
                                              />
                                            ) : (
                                              <Controller
                                                name="description"
                                                control={control}
                                                defaultValue={
                                                  protocol?.description || ''
                                                }
                                                rules={() => {
                                                  if (
                                                    protocolDefaultFieldsDisplaySettings
                                                      ?.description
                                                      ?.isRequired &&
                                                    !valueDescription
                                                  ) {
                                                    validateFields(true);
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <DescriptionUpdateProtocolQuillContainer
                                                    {...field}
                                                    modules={modules}
                                                    theme="snow"
                                                    placeholder="Escreva uma descrição"
                                                    defaultValue={
                                                      protocol?.description
                                                    }
                                                    onChange={
                                                      handleSendDescription
                                                    }
                                                    style={{
                                                      borderRadius: '.25rem'
                                                    }}
                                                  />
                                                )}
                                              />
                                            )}
                                            <ErrorMessage
                                              errors={errors}
                                              name="description"
                                              render={({ message }) =>
                                                errorFormMessage(message)
                                              }
                                            />
                                          </Col>
                                        )}
                                      </Row>
                                      <Row className="mb-3">
                                        {protocolDefaultFieldsDisplaySettings
                                          .email.isActive && (
                                          <Col>
                                            <label className="form-control-label">
                                              {definedShowName(
                                                'Email',
                                                protocolDefaultFieldsDisplaySettings
                                                  .email.isRequired
                                              )}
                                            </label>
                                            <div
                                              style={{ position: 'relative' }}
                                            >
                                              <Controller
                                                as={Input}
                                                control={control}
                                                name="email"
                                                defaultValue={protocol?.email}
                                                disabled={false}
                                                rules={{
                                                  validate: (value) => {
                                                    const isRequired =
                                                      protocolDefaultFieldsDisplaySettings
                                                        .email.isRequired;

                                                    if (isRequired && !value)
                                                      return 'Campo obrigatório';
                                                    if (!isRequired && !value)
                                                      return true;

                                                    const emailRegex =
                                                      // eslint-disable-next-line no-useless-escape
                                                      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

                                                    return (
                                                      emailRegex.test(value) ||
                                                      'Email com formato incorreto'
                                                    );
                                                  }
                                                }}
                                                style={{
                                                  padding:
                                                    '12px 60px 12px 12px',
                                                  height: '48px'
                                                }}
                                              />

                                              <div
                                                style={{
                                                  position: 'absolute',
                                                  right: 48,
                                                  top: '50%',
                                                  transform: 'translateY(-50%)',
                                                  height: '29px',
                                                  width: '1px',
                                                  backgroundColor: '#ccc',
                                                  zIndex: 10
                                                }}
                                              />
                                              <SearchContactButton
                                                style={{
                                                  position: 'absolute',
                                                  right: 4,
                                                  top: 0,
                                                  height: '100%',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  zIndex: 10,
                                                  cursor: 'pointer',
                                                  padding: '0 8px',
                                                  fontSize: '39px'
                                                }}
                                                onClick={() =>
                                                  setIsClientSearchModalOpen(
                                                    true
                                                  )
                                                }
                                              />
                                            </div>
                                            <ErrorMessage
                                              errors={errors}
                                              name="email"
                                              render={({ message }) =>
                                                errorFormMessage(message)
                                              }
                                            />
                                          </Col>
                                        )}

                                        {protocolDefaultFieldsDisplaySettings
                                          .account_id.isActive && (
                                          <Col
                                            md={
                                              protocolDefaultFieldsDisplaySettings
                                                .title.isActive
                                                ? { size: 6 }
                                                : { size: 12 }
                                            }
                                          >
                                            <label className="form-control-label text-capitalize">
                                              Conta
                                            </label>
                                            <div style={{ display: 'flex' }}>
                                              <div style={{ flexGrow: 1 }}>
                                                <Select
                                                  styles={custom_select}
                                                  placeholder="Busca rápida"
                                                  isClearable={true}
                                                  name="accountId"
                                                  isLoading={isSearching}
                                                  loadingMessage={() =>
                                                    'Buscando...'
                                                  }
                                                  noOptionsMessage={({
                                                    inputValue
                                                  }) =>
                                                    !inputValue
                                                      ? 'Digite para pesquisar'
                                                      : 'Nenhum resultado encontrado'
                                                  }
                                                  loadOptions={async (
                                                    inputValue
                                                  ) => {
                                                    const res =
                                                      await filterAccounts(
                                                        inputValue
                                                      );
                                                    return (
                                                      res &&
                                                      res.map((account) => ({
                                                        label: account.name,
                                                        value: account.id,
                                                        recordTypeId:
                                                          account.record_type_id
                                                      }))
                                                    );
                                                  }}
                                                  onChange={(data) => {
                                                    if (data) {
                                                      const {
                                                        value,
                                                        label,
                                                        recordTypeId
                                                      } = data;
                                                      setAccount({
                                                        label,
                                                        value,
                                                        recordTypeId
                                                      });
                                                    } else {
                                                      setAccount(null);
                                                    }
                                                  }}
                                                  value={
                                                    account
                                                      ? {
                                                          label: account.label,
                                                          value: account.value
                                                        }
                                                      : ''
                                                  }
                                                  defaultValue={
                                                    account
                                                      ? {
                                                          label: account.label,
                                                          value: account.value
                                                        }
                                                      : ''
                                                  }
                                                  components={{
                                                    DropdownIndicator: () => (
                                                      <div
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                          e.stopPropagation();
                                                          setIsAccountSearchModalOpen(
                                                            true
                                                          );
                                                        }}
                                                        style={{
                                                          padding: '0.6rem',
                                                          cursor: 'pointer',
                                                          display: 'flex',
                                                          alignItems: 'center'
                                                        }}
                                                      >
                                                        <SearchContactButton
                                                          onClick={() =>
                                                            setIsAccountSearchModalOpen(
                                                              true
                                                            )
                                                          }
                                                          style={{
                                                            margin: 0,
                                                            padding: 0
                                                          }}
                                                        />
                                                      </div>
                                                    )
                                                  }}
                                                />
                                              </div>
                                              <div
                                                style={{
                                                  alignSelf: 'flex-end',
                                                  justifyContent:
                                                    'space-between',
                                                  padding: '0.6rem',
                                                  marginLeft: '0.2rem',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  gap: '0.5rem'
                                                }}
                                              >
                                                <div>
                                                  <Button
                                                    size="sm"
                                                    color="info"
                                                    type="button"
                                                    title="Editar conta"
                                                    onClick={handleEditAccount}
                                                    disabled={!account}
                                                  >
                                                    <li className="fas fa-user-edit"></li>
                                                  </Button>
                                                </div>
                                                <div>
                                                  <AccountProtocol
                                                    accountId={
                                                      protocol?.account?.id
                                                    }
                                                  />
                                                </div>
                                              </div>

                                              <div
                                                style={{
                                                  alignSelf: 'flex-end',
                                                  justifyContent:
                                                    'space-between',
                                                  padding: '0.6rem',
                                                  marginLeft: '-0.5rem'
                                                }}
                                              >
                                                <AddAccountModal
                                                  onAddedAccount={(data) => {
                                                    setAccount({
                                                      label: data.name,
                                                      value: data.id,
                                                      recordTypeId:
                                                        data.record_type_id
                                                    });
                                                  }}
                                                  buttonOpenModal={({
                                                    onClick
                                                  }) => (
                                                    <AddNewContactButton
                                                      onClick={onClick}
                                                    />
                                                  )}
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        )}
                                      </Row>
                                      {!valueFieldsReferenceLoading &&
                                        !!customFields.length && (
                                          <Row>
                                            <CustomFieldsInputsForm
                                              fields={sortedCustomFields}
                                              protocolDTO={protocol}
                                              setValueFieldsReferenceLoading={
                                                setValueFieldsReferenceLoading
                                              }
                                              valueFieldsReferenceLoading={
                                                valueFieldsReferenceLoading
                                              }
                                              control={control}
                                              watch={watch}
                                              errors={errors}
                                              setValue={setValue}
                                              Controller={Controller}
                                              isOnEditPage={true}
                                              options={{
                                                showCallIconOnPhoneField: true,
                                                showMessageIconOnPhoneField: true
                                              }}
                                              contactMessageClientName={selectNameToActiveContactMessage()}
                                            />
                                          </Row>
                                        )}
                                      <Row style={{ marginBottom: '1.5rem' }}>
                                        <Col
                                          md="4"
                                          style={{ paddingTop: '10px' }}
                                        >
                                          <Button
                                            color="primary"
                                            type="submit"
                                            title="Atualizar dados do protocolo"
                                          >
                                            Atualizar
                                          </Button>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Card>
                                  <>
                                    <hr
                                      style={{
                                        marginTop: '-2rem',
                                        border: '20px solid #f1f2f5 ',
                                        width: 'calc(100% + 10px)',
                                        marginLeft: '-25px',
                                        overflow: 'hidden'
                                      }}
                                    />
                                  </>
                                  <Card
                                    style={{
                                      marginTop: '-33px',
                                      width: 'calc(100% + 49px)',
                                      marginLeft: '-24.5px',
                                      borderTop: '1px solid #d3d3d3',
                                      borderLeft: 'none',
                                      borderRight: 'none',
                                      borderBottom: 'none',
                                      borderRadius: '0.25rem',
                                      background: 'transparent',
                                      boxShadow: 'none',
                                      backgroundColor: 'transparent'
                                    }}
                                  >
                                    <h1></h1>
                                  </Card>
                                  <Row className="mb-3">
                                    {protocolDefaultFieldsDisplaySettings
                                      .client_id.isActive && (
                                      <>
                                        <Col
                                          md={
                                            protocolDefaultFieldsDisplaySettings
                                              .service_channel.isActive
                                              ? { size: 5 }
                                              : { size: 11 }
                                          }
                                        >
                                          <label className="form-control-label">
                                            {definedShowName(
                                              'Contato',
                                              protocolDefaultFieldsDisplaySettings
                                                .client_id.isRequired
                                            )}
                                          </label>
                                          <Input
                                            value={protocol?.client?.nome || ''}
                                            disabled
                                          ></Input>
                                        </Col>
                                        <Col
                                          md="1"
                                          xl="1"
                                          style={{
                                            paddingTop: '41px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.5rem'
                                          }}
                                        >
                                          <div>
                                            <Button
                                              title="Atualizar contato"
                                              size="sm"
                                              color="info"
                                              onClick={() =>
                                                setOpenModalUpdateClient(true)
                                              }
                                            >
                                              <li className="fas fa-user-edit"></li>
                                            </Button>
                                          </div>
                                          <div>
                                            <ClientProtocol
                                              recordTypes={recordTypes}
                                              clientId={protocol?.client?.id}
                                            />
                                          </div>
                                        </Col>
                                      </>
                                    )}
                                    {protocolDefaultFieldsDisplaySettings
                                      .service_channel.isActive && (
                                      <Col
                                        md={
                                          protocolDefaultFieldsDisplaySettings
                                            .client_id.isActive
                                            ? { size: 5 }
                                            : { size: 12 }
                                        }
                                      >
                                        <label className="form-control-label">
                                          {definedShowName(
                                            'Canal de atendimento',
                                            protocolDefaultFieldsDisplaySettings
                                              .telephone.isRequired
                                          )}
                                        </label>
                                        <Controller
                                          as={Input}
                                          control={control}
                                          name="service_channel"
                                          defaultValue={
                                            protocol?.service_channel || ''
                                          }
                                          disabled={true}
                                        />
                                      </Col>
                                    )}
                                  </Row>
                                  <Row className="mb-3">
                                    {protocolDefaultFieldsDisplaySettings
                                      .reason_id.isActive && (
                                      <>
                                        <Col
                                          md={
                                            protocolDefaultFieldsDisplaySettings
                                              .subreason_id.isActive
                                              ? { size: 5 }
                                              : { size: 11 }
                                          }
                                        >
                                          <label className="form-control-label">
                                            {definedShowName(
                                              'Motivo',
                                              protocolDefaultFieldsDisplaySettings
                                                .reason_id.isRequired
                                            )}
                                          </label>
                                          <Input
                                            value={protocol?.reason?.name || ''}
                                            disabled
                                          ></Input>
                                        </Col>
                                        <Col
                                          md="1"
                                          style={{ paddingTop: '41px' }}
                                        >
                                          {isUserAbleToEditSlaInfo && (
                                            <Button
                                              title="Atualizar Motivo"
                                              size="sm"
                                              color="info"
                                              onClick={() =>
                                                setOpenModalReason(true)
                                              }
                                            >
                                              <li className="fas fa-user-edit"></li>
                                            </Button>
                                          )}
                                        </Col>
                                      </>
                                    )}
                                    {protocolDefaultFieldsDisplaySettings
                                      .subreason_id.isActive && (
                                      <>
                                        <Col
                                          md={
                                            protocolDefaultFieldsDisplaySettings
                                              .reason_id.isActive
                                              ? { size: 5 }
                                              : { size: 11 }
                                          }
                                        >
                                          <label className="form-control-label">
                                            {definedShowName(
                                              'Submotivo',
                                              protocolDefaultFieldsDisplaySettings
                                                .subreason_id.isRequired
                                            )}
                                          </label>
                                          <Input
                                            value={
                                              protocol?.subreason?.name || ''
                                            }
                                            disabled
                                          ></Input>
                                        </Col>
                                        <Col
                                          md="1"
                                          style={{ paddingTop: '41px' }}
                                        >
                                          {isUserAbleToEditSlaInfo && (
                                            <Button
                                              title="Atualizar Submotivo"
                                              size="sm"
                                              color="info"
                                              onClick={() =>
                                                setOpenModalSubReason(true)
                                              }
                                            >
                                              <li className="fas fa-user-edit"></li>
                                            </Button>
                                          )}
                                        </Col>
                                      </>
                                    )}
                                  </Row>
                                  <Row className="mb-3">
                                    <Col
                                      md={
                                        protocolDefaultFieldsDisplaySettings
                                          .current_status.isActive
                                          ? { size: 5 }
                                          : { size: 11 }
                                      }
                                    >
                                      <label className="form-control-label">
                                        Responsável*
                                      </label>
                                      <Controller
                                        as={Input}
                                        control={control}
                                        name="current_responsible"
                                        defaultValue={
                                          protocol?.protocol_responsibles?.[0]
                                            ?.usr?.name || ''
                                        }
                                        disabled={true}
                                      />
                                    </Col>
                                    <Col md="1" style={{ paddingTop: '41px' }}>
                                      <Button
                                        title="Atualizar Responsável"
                                        size="sm"
                                        color="info"
                                        onClick={() => setOpenModalUser(true)}
                                      >
                                        <li className="fas fa-user-edit"></li>
                                      </Button>
                                    </Col>

                                    <Col
                                      md={
                                        protocolDefaultFieldsDisplaySettings
                                          ?.current_status.isActive
                                          ? { size: 5 }
                                          : { size: 11 }
                                      }
                                    >
                                      <label className="form-control-label">
                                        Agente do protocolo*
                                      </label>
                                      <Controller
                                        as={Input}
                                        control={control}
                                        name="new_agent_id"
                                        defaultValue={
                                          protocol?.notification_agent
                                            ?.agent_user?.name ?? ''
                                        }
                                        disabled={true}
                                      />
                                    </Col>
                                    <Col md="1" style={{ paddingTop: '41px' }}>
                                      <Button
                                        title="Atualizar Agente do protocolo"
                                        size="sm"
                                        color="info"
                                        onClick={() =>
                                          setOpenModalNotificationAgent(true)
                                        }
                                      >
                                        <li className="fas fa-user-edit"></li>
                                      </Button>
                                    </Col>
                                  </Row>
                                  <Row className="mb-3">
                                    {protocolDefaultFieldsDisplaySettings
                                      .current_status.isActive && (
                                      <>
                                        <Col
                                          md={
                                            protocolDefaultFieldsDisplaySettings
                                              .current_status.isActive
                                              ? { size: 5 }
                                              : { size: 11 }
                                          }
                                        >
                                          <label className="form-control-label">
                                            {definedShowName(
                                              'Status/Fase',
                                              protocolDefaultFieldsDisplaySettings
                                                .current_status.isRequired
                                            )}
                                          </label>
                                          <Input
                                            value={
                                              currentStatusDisplay.name ||
                                              getFallbackStatusName(protocol) ||
                                              ''
                                            }
                                            disabled
                                          />
                                        </Col>
                                        <Col
                                          md="1"
                                          style={{ paddingTop: '41px' }}
                                        >
                                          <Button
                                            title="Atualizar Status/Fase"
                                            size="sm"
                                            color="info"
                                            onClick={() =>
                                              setOpenModalStatus(true)
                                            }
                                          >
                                            <li className="fas fa-user-edit"></li>
                                          </Button>
                                        </Col>
                                      </>
                                    )}
                                  </Row>
                                </>
                              )}
                          </Form>
                          <Row className="mb-3">
                            <Col md={'11'}>
                              <label className="form-control-label">
                                Protocolos Associados (
                                {subProtocols.length + (parentProtocol ? 1 : 0)}
                                )
                              </label>
                            </Col>
                            <Col md="11">
                              <SubProtocolList
                                parentProtocol={parentProtocol}
                                list={subProtocols}
                                handleRedirect={handleRedirect}
                              />
                            </Col>
                          </Row>
                          {listSchedules ? (
                            <ListSchedules
                              listSchedules={listSchedules}
                              handleUpdateSchedule={handleUpdateSchedule}
                              cancelSchedule={cancelSchedule}
                            />
                          ) : (
                            <Row className="justify-content-md-center">
                              <Loader
                                type="TailSpin"
                                color="#35ac50"
                                height={100}
                                width={100}
                              />
                            </Row>
                          )}
                          <ModalSchedulingProtocol
                            className="modal-lg"
                            show={isSchedulingModalOpen}
                            onModalToggle={setIsSchedulingModalOpen}
                            schedulingId={schedulingId}
                            setschedulingId={setschedulingId}
                            isToCreateScheduling={isToCreateScheduling}
                            isToUpdateScheduling={isToUpdateScheduling}
                            protocolId={protocol.id}
                            getProtocolById={getProtocolById}
                            isFromNotification={false}
                            isCurrentResponsible={isCurrentResponsible}
                          />
                          <Col className="text-right">
                            <Button
                              title="Adicionar novo agendamento"
                              color="success"
                              type="button"
                              onClick={() => {
                                setIsSchedulingModalOpen(true);
                                setIsToCreateScheduling(true);
                              }}
                            >
                              <FiPlus size={16} /> Adicionar agendamento
                            </Button>
                          </Col>
                          <h3 className="form-control-label mt-2">Anexo(s)</h3>
                          <ProtocolAttachments
                            protocolId={protocol?.id}
                            attachments={protocol?.attachments}
                            onAdded={(addedAttachments) => {
                              setProtocol((prev) => ({
                                ...prev,
                                attachments: [
                                  ...prev.attachments,
                                  ...addedAttachments
                                ]
                              }));
                            }}
                            onDeleted={(attachmentId) => {
                              const remainAttachments =
                                protocol.attachments.filter(
                                  (att) => att.id !== attachmentId
                                );
                              setProtocol((prev) => ({
                                ...prev,
                                attachments: remainAttachments
                              }));
                            }}
                          />
                          {listComments ? (
                            <Row className="mt-3">
                              <Col md="12">
                                <label className="form-control-label">
                                  Comentário(s)
                                </label>
                              </Col>
                              <Col md="12">
                                <div
                                  className="d-flex flex-column"
                                  style={{
                                    gap: '1rem'
                                  }}
                                >
                                  {transformComments(listComments).map(
                                    (item, index) => (
                                      <>
                                        {item.isGroup && visibleGroups ? (
                                          <div key={`group-${index}`}>
                                            {item.count > 1 && (
                                              <ShowMoreButton
                                                visibleGroups={visibleGroups}
                                                index={index}
                                                toggle={() =>
                                                  setVisibleGroups((prev) => ({
                                                    ...prev,
                                                    [index]: !prev[index]
                                                  }))
                                                }
                                              />
                                            )}
                                            <ul
                                              style={{
                                                display:
                                                  visibleGroups[index] ||
                                                  item.count === 1
                                                    ? 'block'
                                                    : 'none',
                                                listStyle: 'disc'
                                              }}
                                            >
                                              {(visibleGroups[index] ||
                                                item.count === 1) &&
                                                item.comments.map((comment) => (
                                                  <SlaActivityHistory
                                                    key={comment.id}
                                                    comment={comment}
                                                  />
                                                ))}
                                            </ul>
                                          </div>
                                        ) : (
                                          <CommentContainer
                                            key={item.id}
                                            id={item.id}
                                            comment={item}
                                            onDelete={handleDeleteComment(
                                              item.id
                                            )}
                                            onUpdate={handleUpdateComment(
                                              item.id
                                            )}
                                            email={protocol.email}
                                            scrollToCommentForm={
                                              scrollToQuillCommentForm
                                            }
                                            onReplyComment={handleReplyComment}
                                            onForwardComment={
                                              handleForwardComment
                                            }
                                            isSelected={selectedComments.includes(
                                              item.id
                                            )}
                                            onSelect={handleSelectComment}
                                            parentComment={getParentComment(
                                              item.reply_to_comment
                                            )}
                                            forwardedItems={getCommentsForwarded(
                                              item
                                            )}
                                            protocolId={protocol?.id}
                                            protocol={protocol}
                                            onRefresh={getCommnents}
                                          />
                                        )}
                                      </>
                                    )
                                  )}
                                </div>
                              </Col>
                            </Row>
                          ) : (
                            <Row className="justify-content-md-center">
                              <Loader
                                type="TailSpin"
                                color="#35ac50"
                                height={100}
                                width={100}
                              />
                            </Row>
                          )}
                          <Row className="my-3">
                            <Col md="12">
                              {replyComment && (
                                <RepliedCommentContainer
                                  comment={replyComment}
                                  onClose={handleCloseReplyCommentBox}
                                />
                              )}
                              {isForwardingComment &&
                                selectedComments.length > 0 && (
                                  <div className="mb-3">
                                    {selectedComments.map((commentId) => {
                                      const selectedComment = listComments.find(
                                        (c) => c.id === commentId
                                      );
                                      return (
                                        <ForwardedCommentContainer
                                          key={commentId}
                                          comment={selectedComment}
                                          onClose={() => {
                                            setIsForwardingComment(false);
                                            setSelectedComments([]);
                                          }}
                                        />
                                      );
                                    })}
                                  </div>
                                )}
                              <div ref={scrollQuillForm}>
                                <CommentsForm
                                  ref={scrollQuillForm}
                                  onSubmit={
                                    isForwardingComment
                                      ? handleSubmitForward
                                      : handleSubmitComment
                                  }
                                  protocol={{
                                    ...protocol,
                                    comments: listComments,
                                    selectedComments
                                  }}
                                  replyCommentId={replyComment?.id}
                                  replyCommentsEmails={formatCommentRecipients(
                                    replyComment
                                  )}
                                  onCloseReplyBox={handleCloseReplyCommentBox}
                                  isForwardingComment={isForwardingComment}
                                  onForwardAll={handleForwardAll}
                                  setIsForwardingComment={
                                    setIsForwardingComment
                                  }
                                  onProtocolUpdate={getProtocolById}
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row style={{ paddingTop: '20px' }}>
                            <Col className="text-left">
                              <Button
                                color="danger"
                                onClick={() => cancelAction()}
                              >
                                Voltar
                              </Button>
                            </Col>
                          </Row>
                        </>
                      )
                    )}
                  </CardBody>
                </Card>
              </div>
            </div>
          </Row>
          {protocol && (
            <>
              {protocolDefaultFieldsDisplaySettings &&
                !!Object.keys(protocolDefaultFieldsDisplaySettings).length && (
                  <>
                    <ModalStatus
                      render={(newStatus) => {
                        const copy = { ...protocol };
                        copy.protocol_statuses[0] = newStatus;
                        copy.current_status = newStatus.id;
                        setCurrentStatusDisplay({
                          id: newStatus.id || '',
                          name: newStatus.name || ''
                        });
                        setProtocol({ ...copy });
                      }}
                      recordTypeId={protocol.record_type_id}
                      idProtocol={protocol.id}
                      idStatusProtocol={getCurrentStatusId(protocol)}
                      isModalOpen={openModalStatus}
                      onModalToggle={setOpenModalStatus}
                      unmountOnClose={true}
                      isRequired={
                        protocolDefaultFieldsDisplaySettings?.current_status
                          ?.isRequired || true
                      }
                    />
                    <ModalUser
                      render={(newUser) => {
                        protocol.current_responsible = newUser.name;
                        setValue('current_responsible', newUser.name);
                      }}
                      idProtocol={protocol.id}
                      idUserProtocol={
                        protocol?.protocol_responsibles?.[0]?.responsible_id
                      }
                      recordTypeId={protocol?.record_type_id}
                      isModalOpen={openModalUser}
                      onModalToggle={setOpenModalUser}
                      unmountOnClose={true}
                    />
                    <ModalNotificationAgent
                      onNewAgentSelected={(newAgent) =>
                        setValue('new_agent_id', newAgent)
                      }
                      protocolId={protocol?.id}
                      recordTypeId={protocol?.record_type_id}
                      isModalOpen={openModalNotificationAgent}
                      onModalToggle={setOpenModalNotificationAgent}
                      unmountOnClose={true}
                    />
                    <ModalReason
                      render={(newData) => {
                        if (newData.reason) {
                          protocol.reason = newData.reason;
                          protocol.reason_id = newData.reason.id;
                        }
                        if (newData.subreason) {
                          protocol.subreason = newData.subreason;
                          protocol.subreason_id = newData.subreason.id;
                        }
                        setValue('reason_id', newData?.reason?.name);
                        setValue('subreason_id', newData?.subreason?.name);
                      }}
                      recordTypeId={protocol.record_type_id}
                      idProtocol={protocol.id}
                      isModalOpen={openModalReason}
                      onModalToggle={setOpenModalReason}
                      unmountOnClose={true}
                      isRequired={
                        protocolDefaultFieldsDisplaySettings?.reason_id
                          ?.isRequired || true
                      }
                      reasonIsRequiredSubReason={
                        protocolDefaultFieldsDisplaySettings?.subreason_id
                          ?.isRequired
                      }
                      showSubReason={
                        protocolDefaultFieldsDisplaySettings?.subreason_id
                          ?.isActive
                      }
                    />
                    <ModalSubReason
                      render={(newSubreason) => {
                        protocol.subreason = newSubreason;
                        protocol.subreason_id = newSubreason.id;
                        setValue('subreason_id', newSubreason.name);
                      }}
                      idProtocol={protocol.id}
                      idReasonProtocol={protocol?.reason_id}
                      isModalOpen={openModalSubReason}
                      onModalToggle={setOpenModalSubReason}
                      unmountOnClose={true}
                      isRequired={
                        protocolDefaultFieldsDisplaySettings?.subreason_id
                          ?.isRequired || true
                      }
                    />
                    <ModalClient
                      render={(newClient) => {
                        const copy = { ...protocol };
                        copy.client = newClient;

                        if (protocol.client.id !== newClient.id) {
                          setProtocol({ ...copy });
                          setValue('client_id', newClient.name);
                        }
                      }}
                      contact={{
                        email: protocol?.email || '',
                        id: protocol?.client?.id || ''
                      }}
                      idProtocol={protocol.id}
                      isModalOpen={openModalUpdateClient}
                      onModalToggle={setOpenModalUpdateClient}
                      unmountOnClose={true}
                      isRequired={
                        protocolDefaultFieldsDisplaySettings?.client_id
                          ?.isRequired || true
                      }
                    />
                  </>
                )}
            </>
          )}
        </Container>
      </>
      <TemplatesModal
        isModalOpen={isModalTemplateMessageProtocolOpen}
        onModalToggle={setIsisModalTemplateMessageProtocolOpen}
        clientNumber={whatsAppMessageContactInfoProtocol?.telefone}
        clientDDI={whatsAppMessageContactInfoProtocol?.ddi}
        clientName={whatsAppMessageContactInfoProtocol?.nome}
        clientId={whatsAppMessageContactInfoProtocol?.clientId ?? ''}
        isIsolated={true}
      />
      <ModalFilterClients
        className="modal-lg"
        show={isAccountSearchModalOpen}
        onModalToggle={setIsAccountSearchModalOpen}
        setSelectedClient={(account) => {
          setAccount({
            value: account?.clientId,
            label: account?.clientName,
            recordTypeId: account?.accountRecordTypeId
          });
          setIsAccountSearchModalOpen(false);
        }}
        account={true}
        recordTypes={[]}
        customFields={[]}
      />

      <ModalFilterClients
        className="modal-lg"
        show={isClientSearchModalOpen}
        onModalToggle={setIsClientSearchModalOpen}
        setSelectedClient={(contact) => {
          if (contact?.clientEmail) {
            setValue('email', contact.clientEmail);
          }
          setIsClientSearchModalOpen(false);
        }}
      />
      <EditAccountModal
        isModalOpen={isEditAccountModalOpen}
        onModalToggle={setIsEditAccountModalOpen}
        account={accountResponse}
        recordTypeId={account?.recordTypeId}
        setSelectedClient={(account) => {
          setAccount({
            value: account?.clientId,
            label: account?.clientName,
            recordTypeId: account?.accountRecordTypeId
          });
        }}
      />
    </>
  );
};

export default ProtocolFormUpdate;
